import * as Yup from 'yup'

export const initialSuperEndWetValues = {
  wetName: '',
  wetDate: '',
  wetShift: '',
  wetMessage: '',
  wetAlarmNotice: '',
  wetBrokenStateSeals: '',
  intakeComments: '',
  creamLoadOuts: '',
  intakeDowntime: '',
  intakeDowntimeReasons: '',
  wpComments: '',
  wpCipComments: '',
  wpHistRegulatoryIssues: '',
  sep1Dislodge: '',
  sep2Dislodge: '',
  sep3Dislodge: '',
  sepDislodgeComments: '',
  ufComments: '',
  nfComments: '',
  permeateComments: '',
  butterComments: '',
  butterPalletsProduced: '',
  butterRemeltedPalletIds: '',
  avgFatChurn1: '',
  avgFatChurn2: '',
  employeeButterCases: '',
  wetGmpViolations: '',
  wetGmpViolationComments: '',
  wetAuditDate: '',
  wetAuditTasksCompleted: '',
  wetUsdaAuditTasksCompleted: '',
}

export const SuperEndWetSchema = Yup.object().shape({
  logId: Yup.string(),
  wetName: Yup.string(),
  wetDate: Yup.string(),
  wetShift: Yup.string(),
  wetMessage: Yup.string(),
  wetAlarmNotice: Yup.string(),
  wetBrokenStateSeals: Yup.string(),
  intakeComments: Yup.string(),
  creamLoadOuts: Yup.string(),
  intakeDowntime: Yup.string(),
  intakeDowntimeReasons: Yup.string(),
  wpComments: Yup.string(),
  wpCipComments: Yup.string(),
  wpHistRegulatoryIssues: Yup.string(),
  sep1Dislodge: Yup.string(),
  sep2Dislodge: Yup.string(),
  sep3Dislodge: Yup.string(),
  sepDislodgeComments: Yup.string(),
  ufComments: Yup.string(),
  nfComments: Yup.string(),
  permeateComments: Yup.string(),
  butterComments: Yup.string(),
  butterPalletsProduced: Yup.string(),
  butterRemeltedPalletIds: Yup.string(),
  avgFatChurn1: Yup.string(),
  avgFatChurn2: Yup.string(),
  employeeButterCases: Yup.string(),
  wetGmpViolations: Yup.string(),
  wetGmpViolationComments: Yup.string(),
  wetAuditDate: Yup.string(),
  wetAuditTasksCompleted: Yup.string(),
  wetUsdaAuditTasksCompleted: Yup.string(),
})
